import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const STOPS = [
  { id: "hong_kong", name: "Hong Kong", cn: "香港", x: 70, y: 210, dates: "20–22 Oct", nights: 2 },
  { id: "shenzhen", name: "Shenzhen", cn: "深圳", x: 170, y: 140, dates: "22–24 Oct", nights: 2 },
  { id: "yangshuo", name: "Yangshuo", cn: "阳朔", x: 300, y: 60, dates: "24–26 Oct", nights: 2 },
  { id: "guangzhou", name: "Guangzhou", cn: "广州", x: 410, y: 170, dates: "26–29 Oct", nights: 3 },
];
const PATH = "M70 210 C 110 200, 130 150, 170 140 S 250 40, 300 60 S 380 110, 410 170";

export function RouteVisual({ compact = false, activeId, dark = false, onSelect }) {
  const navigate = useNavigate();
  const stroke = dark ? "#C69B56" : "#17382F";
  const label = dark ? "#FBF9F5" : "#1E2221";
  const sub = dark ? "rgba(251,249,245,0.7)" : "#5F6563";
  return (
    <svg data-testid="route-visual" viewBox="0 0 480 260" className={`w-full ${compact ? "max-h-56" : ""}`} role="img" aria-label="Route: Hong Kong to Shenzhen to Yangshuo to Guangzhou">
      <path d={PATH} fill="none" stroke={stroke} strokeOpacity="0.25" strokeWidth="6" strokeLinecap="round" />
      <path d={PATH} fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeDasharray="6 8" className="route-line" />
      {STOPS.map((s, i) => (
        <motion.g key={s.id} initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.5 + i * 0.35, duration: 0.5 }} style={{ transformOrigin: `${s.x}px ${s.y}px`, cursor: "pointer" }}
          onClick={() => (onSelect ? onSelect(s.id) : navigate(`/trip?city=${s.id}`))} data-testid={`route-stop-${s.id}`}>
          <circle cx={s.x} cy={s.y} r={activeId === s.id ? 16 : 12} fill={dark ? "#0F2620" : "#FBF9F5"} stroke={activeId === s.id ? "#D97757" : stroke} strokeWidth="2.5" />
          <circle cx={s.x} cy={s.y} r="4.5" fill={activeId === s.id ? "#D97757" : "#C69B56"} />
          <text x={s.x} y={s.y - 24} textAnchor="middle" fontFamily="Cormorant Garamond, serif" fontWeight="600" fontSize="19" fill={label}>{s.name}</text>
          <text x={s.x} y={s.y + 36} textAnchor="middle" fontFamily="Noto Serif SC, serif" fontSize="13" fill={sub}>{s.cn}</text>
          {!compact && <text x={s.x} y={s.y + 52} textAnchor="middle" fontFamily="Plus Jakarta Sans, sans-serif" fontSize="10" fill={sub} letterSpacing="1">{s.dates} · {s.nights} nights</text>}
        </motion.g>
      ))}
    </svg>
  );
}
export const ROUTE_STOPS = STOPS;
